import { atom } from '@reatom/framework'

/* eslint-disable @reatom/unit-naming-rule */
export const reatomPairTrades = () => {
  const hasLiquidityRemovedTxAtom = atom<boolean>(false)

  return {
    hasLiquidityRemovedTx: hasLiquidityRemovedTxAtom,
  }
}
